import { NoteDetailFormValue } from '../../../../../coaching-note/note-detail-form-value.model';
import { createAction } from '../../../../../store.model';
import { User } from '../../../../../user/user.model';
import { ActionType } from '../commitment-narrative.action';

export interface AddNote {
    user?: User;
    notes?: NoteDetailFormValue[];
}

export const addNote = createAction<ActionType, AddNote>(
    ActionType.COMMITMENT_NARRATIVE__ADD_NOTE,
);
